import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import RequireAuth from "@/components/RequireAuth";
import Layout from "@/components/Layout";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import BookingsPage from "@/pages/BookingsPage";
import BookingDetailPage from "@/pages/BookingDetailPage";
import BookingNewPage from "@/pages/BookingNewPage";
import CalendarPage from "@/pages/CalendarPage";
import QuotationsPage from "@/pages/QuotationsPage";
import QuotationDetailPage from "@/pages/QuotationDetailPage";
import InvoicesPage from "@/pages/InvoicesPage";
import InvoiceDetailPage from "@/pages/InvoiceDetailPage";
import PaymentsPage from "@/pages/PaymentsPage";
import CustomersPage from "@/pages/CustomersPage";
import InventoryPage from "@/pages/InventoryPage";
import PackagesPage from "@/pages/PackagesPage";
import PreparationPage from "@/pages/PreparationPage";
import CheckoutPage from "@/pages/CheckoutPage";
import ReturnPage from "@/pages/ReturnPage";
import MaintenancePage from "@/pages/MaintenancePage";
import ReportsPage from "@/pages/ReportsPage";
import NotificationsPage from "@/pages/NotificationsPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import AuditLogPage from "@/pages/AuditLogPage";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <RequireAuth>
                <Layout />
              </RequireAuth>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/bookings" element={<BookingsPage />} />
            <Route path="/bookings/new" element={<BookingNewPage />} />
            <Route path="/bookings/:id" element={<BookingDetailPage />} />
            <Route path="/quotations" element={<QuotationsPage />} />
            <Route path="/quotations/:id" element={<QuotationDetailPage />} />
            <Route path="/invoices" element={<RequireAuth roles={["finance", "booking_admin"]}><InvoicesPage /></RequireAuth>} />
            <Route path="/invoices/:id" element={<RequireAuth roles={["finance", "booking_admin"]}><InvoiceDetailPage /></RequireAuth>} />
            <Route path="/payments" element={<RequireAuth roles={["finance"]}><PaymentsPage /></RequireAuth>} />
            <Route path="/customers" element={<CustomersPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/preparation" element={<PreparationPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/:id" element={<CheckoutPage />} />
            <Route path="/return" element={<ReturnPage />} />
            <Route path="/return/:id" element={<ReturnPage />} />
            <Route path="/maintenance" element={<MaintenancePage />} />
            <Route path="/reports" element={<RequireAuth roles={["finance", "booking_admin"]}><ReportsPage /></RequireAuth>} />
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/users" element={<RequireAuth roles={[]}><UsersPage /></RequireAuth>} />
            <Route path="/admin" element={<Navigate to="/users" replace />} />
            <Route path="/admin/users" element={<RequireAuth roles={[]}><UsersPage /></RequireAuth>} />
            <Route path="/admin/audit-log" element={<RequireAuth roles={[]}><AuditLogPage /></RequireAuth>} />
            <Route path="/admin/settings" element={<RequireAuth roles={[]}><SettingsPage /></RequireAuth>} />
            <Route path="/audit-log" element={<RequireAuth roles={[]}><AuditLogPage /></RequireAuth>} />
            <Route path="/settings" element={<RequireAuth roles={[]}><SettingsPage /></RequireAuth>} />
          </Route>
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
